/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from '../request.js'

// 卡锁定列表
export function listCardLock(params) {
    return request({
        url: 'cardLock/list.do?',
        method: 'post',
        data: params
    })
}

// 删除卡锁定
export function deleteCardLock(params) {
    return request({
        url: 'cardLock/deleteById.do?',
        method: 'post',
        data: params
    })
}

// 批量新增卡锁定
export function batchSaveCardLock(params) {
    return request({
        url: 'cardLock/batchSave.do?',
        method: 'post',
        data: params
    })
}
